/**
 * Ryan O'Dowd
 * 2024-03-10
 * © Copyright 2024 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = () => {
  return {
    container: {
      marginTop: 8,
      flexWrap: 'wrap',
    },
    pickerAndButtonWrapper: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
    },
    pickerWrapper: {
      flex: 1,
    },
  };
};

export default getStyles;
